/**
 * Calendar — Screen 6 (V1: fully greyed placeholder)
 */

import React from 'react';
import { GreyedPage } from '../../components/ComingSoon.js';

export function CalendarPage() {
  return (
    <div>
      <div className="flex items-start justify-between mb-6">
        <div>
          <h1
            className="text-[22px] font-bold text-ink tracking-[-0.01em]"
            style={{ fontFamily: '"Plus Jakarta Sans", system-ui' }}
          >
            Calendar
          </h1>
          <p className="text-[13.5px] text-muted mt-0.5">
            Week of Jul 6 – 12 · 9 appointments · all booked by Ava in each lead's local time zone
          </p>
        </div>
        <div className="flex items-center gap-2">
          <button
            className="px-3 py-1.5 rounded-btn text-[11.5px] font-medium text-ink opacity-40 cursor-not-allowed"
            style={{ background: '#F2F4F7', border: '1px solid #E5EAF2' }}
          >
            Booking rules
          </button>
          <div
            className="flex rounded-[10px] overflow-hidden opacity-40"
            style={{ border: '1px solid #E5EAF2' }}
          >
            <button className="px-3 py-1.5 text-[12px] font-medium text-muted" style={{ background: '#0D172918' }}>
              Week
            </button>
            <button className="px-3 py-1.5 text-[12px] font-medium text-muted">
              Agenda
            </button>
          </div>
        </div>
      </div>

      <GreyedPage
        title="Calendar — Coming soon"
        icon="📅"
        description="Drag-to-reschedule calendar view, booking rules slide-over, and Google Calendar sync are in the next sprint. Ava is still booking appointments now."
      />
    </div>
  );
}
